import { useEffect } from 'react';
import fetchFlags from 'legacy-src/utility/featureFlag/fetchFlags';
import log from 'chameleon/ui-stack/utilities/log';

const useMaintenancePage = ({ flagTrafficKeys, setFeatureFlagAction }) => {
  const callback = (treatments) => {
    const value = treatments.treatment
      ? treatments.treatment === 'on'
      : treatments;
    setFeatureFlagAction({
      show_maintenance_page: value,
    });
  };
  useEffect(() => {
    flagTrafficKeys.some((flagTrafficKey) => {
      fetchFlags(
        'show_maintenance_page',
        flagTrafficKey,
        null,
        {
          singleFlagSplitFunction: 'getTreatmentWithConfig',
          multipleFlagSplitFunction: 'getTreatmentsWithConfig',
        },
        callback,
      )
        .then((featureFlagStatus) => {
          setFeatureFlagAction({
            show_maintenance_page: featureFlagStatus.treatment
              ? featureFlagStatus.treatment === 'on'
              : featureFlagStatus,
          });
        })
        .catch((error) => {
          log('error', error);
        });
    });
  }, flagTrafficKeys);
  return null;
};

export default useMaintenancePage;
